module.exports = __webpack_public_path__ + "media/images/lb/580-98782efb43acddc7ed19974983f1398a.svg";